__turbopack_context__.v({
  "category": "CategoryContainer-module-scss-module__ilAElG__category",
  "categoryContainer": "CategoryContainer-module-scss-module__ilAElG__categoryContainer",
  "categoryLink": "CategoryContainer-module-scss-module__ilAElG__categoryLink",
  "service": "CategoryContainer-module-scss-module__ilAElG__service",
  "serviceLink": "CategoryContainer-module-scss-module__ilAElG__serviceLink",
  "servicesContainer": "CategoryContainer-module-scss-module__ilAElG__servicesContainer",
});
